var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "x-tag-cloud" },
    _vm._l(_vm.tags, function(tag) {
      return _c(
        "div",
        { key: `${_vm.id}-${tag.id}`, staticClass: "tag-item" },
        [
          _vm.type === "checkbox"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checked,
                    expression: "checked"
                  }
                ],
                staticClass: "tag-input",
                attrs: {
                  id: `${_vm.id}-${tag.id}`,
                  name: _vm.id,
                  type: "checkbox"
                },
                domProps: {
                  value: tag.id,
                  checked: Array.isArray(_vm.checked)
                    ? _vm._i(_vm.checked, tag.id) > -1
                    : _vm.checked
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.checked,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = tag.id,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.checked = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.checked = $$c
                    }
                  }
                }
              })
            : _vm.type === "radio"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checked,
                    expression: "checked"
                  }
                ],
                staticClass: "tag-input",
                attrs: {
                  id: `${_vm.id}-${tag.id}`,
                  name: _vm.id,
                  type: "radio"
                },
                domProps: {
                  value: tag.id,
                  checked: _vm._q(_vm.checked, tag.id)
                },
                on: {
                  change: function($event) {
                    _vm.checked = tag.id
                  }
                }
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checked,
                    expression: "checked"
                  }
                ],
                staticClass: "tag-input",
                attrs: {
                  id: `${_vm.id}-${tag.id}`,
                  name: _vm.id,
                  type: _vm.type
                },
                domProps: { value: tag.id, value: _vm.checked },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.checked = $event.target.value
                  }
                }
              }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "tag-label", attrs: { for: `${_vm.id}-${tag.id}` } },
            [_vm._v("\n      " + _vm._s(tag.name) + "\n    ")]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }